import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { __ } from 'react-i18n';
import { FlexCol, FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { Title } from '../General/Text';
import { Tag, TagType } from '../Product/ProductTag';
import { ImageGalleryThumbnails } from './ImageGalleryThumbnails';

interface Props {
  title: string;
  topImage: string;
  images: any[];
  theme: any;
  isnew: number;
  issale: number;
  openModal: (index) => void;
}

function LeftUpper({
  title,
  topImage,
  images,
  theme,
  isnew,
  issale,
  openModal,
}: Props) {
  return (
    <Wrapper>
      <ImageWithGallery>
        {/* tslint:disable-next-line:jsx-no-lambda*/}
        <TopImageWrapper onClick={() => openModal(0)} src={topImage}>
          <TagWrapper>
            {isnew ? <Tag type={TagType.NEW} text={'Novinka'} /> : null}
            {issale ? (
              <Tag
                style={{ marginLeft: isnew ? rem(8) : 0 }}
                type={TagType.ACTION}
                text={'Akcia'}
              />
            ) : null}
          </TagWrapper>
        </TopImageWrapper>
        <ImageGalleryThumbnails images={images} openModal={openModal} />
      </ImageWithGallery>
      <MobileTitle marginTop={0}>{title}</MobileTitle>
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 50%;
  color: ${({ theme }) => theme.colors.white};
  position: relative;

  ${({ theme }) => theme.mediab.l925`
    margin: 0 auto;
  `}

  ${({ theme }) => theme.mediab.m810`
    width: 100%;
    max-width: initial;
  `}
`;

const ImageWithGallery = styled(FlexCol)``;

const TopImageWrapper = styled.div<{ src: string }>`
  max-width: ${rem(608)};
  height: ${rem(608)};
  width: 100%;
  background-image: url('${({ src }) => src}');
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
  cursor: pointer;
  ${({ src }) =>
    src.includes('placeholder') ? 'background-size: contain;' : ''}

  ${({ theme }) => theme.mediab.m810`
    margin: 0 auto;
    background-size: contain;
    height: ${rem(254)};
  `}
`;

const TagWrapper = styled(FlexRow)`
  position: absolute;
  top: 0;
  left: 0;
`;

const MobileTitle = styled(Title)`
  display: none;
  font-family: ${({ theme }) => theme.font.secondary};
  color: ${({ theme }) => theme.colors.tertiary};
  font-weight: 500;
  font-size: ${rem(24)};
  line-height: ${rem(28)};
  margin-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.m810`
    display: block;
  `}
`;

const WithThemeLeftUpper: any = withTheme(LeftUpper);
export { WithThemeLeftUpper as LeftUpper };
